<div class="container">
  <h1 class="page-title"><span class="icon"><i class="fas fa-money-bill-transfer"></i></span>{{ 'TariffRate.Header' | translate }}</h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'TariffRateNew.New' | translate }}" [selected]="isSearchFormOpen">
        <form [formGroup]="addForm">
          <div class="p-fluid formgrid grid">
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRateNew.Forwarder' | translate }}</label>
              <div class="col-8 item">
                <p-dropdown formControlName="forwarder" [filter]="true" [options]="forwarderOptions" [(ngModel)]="tariffRate.forwarder" optionValue="value"></p-dropdown>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'TariffRateNew.SKU' | translate }}</label>
              <div class="col-8 item">
                <input type="text" pInputText [class]="(submitted && f.sku.errors) ? ['ng-invalid', 'ng-dirty'] : []" formControlName="sku" [(ngModel)]="tariffRate.sku" />
                <small *ngIf="submitted && f.sku.errors" class="errors">
                    <div *ngIf="f.sku.errors.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'TariffRateNew.TariffRate' | translate }}</label>
              <div class="col-8 item">
                <p-inputNumber [class]="(submitted && f.tariffRate.errors) ? ['ng-invalid', 'ng-dirty'] : []" formControlName="tariffRate" [(ngModel)]="tariffRate.tariffRate " mode="decimal" [minFractionDigits]="5" [maxFractionDigits]="5" [maxlength]="15"></p-inputNumber>
                <small *ngIf="submitted && f.tariffRate.errors" class="errors">
                    <div *ngIf="f.tariffRate.errors.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'TariffRateNew.CustomsNum' | translate }}</label>
              <div class="col-8 item">
                <input type="text" pInputText [class]="(submitted && f.customsTariff.errors) ? ['ng-invalid', 'ng-dirty'] : []" formControlName="customsTariff" [(ngModel)]="tariffRate.customsTariff" />
                <small *ngIf="submitted && f.customsTariff.errors" class="errors">
                    <div *ngIf="f.customsTariff.errors.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRateNew.PartNumDescription' | translate }}</label>
              <div class="col-8 item">
                <input type="text" pInputText formControlName="skuDescription" [(ngModel)]="tariffRate.skuDescription" />
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'TariffRateNew.FilingDate' | translate }}</label>
              <div class="col-8 item">
                <p-calendar dataType="string" dateFormat="yy/mm/dd" [class]="(submitted && f.declarationDtTimeZone.errors) ? ['ng-invalid', 'ng-dirty'] : []" formControlName="declarationDtTimeZone" [(ngModel)]="tariffRate.declarationDtTimeZone"></p-calendar>
                <small *ngIf="submitted && f.declarationDtTimeZone.errors" class="errors">
                    <div *ngIf="f.declarationDtTimeZone.errors.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'TariffRateNew.Brand' | translate }}</label>
              <div class="col-8 item">
                <input type="text" pInputText [class]="(submitted && f.brand.errors) ? ['ng-invalid', 'ng-dirty'] : []" formControlName="brand" [(ngModel)]="tariffRate.brand" />
                <small *ngIf="submitted && f.brand.errors" class="errors">
                    <div *ngIf="f.brand.errors.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRateNew.IsValid' | translate }}</label>
              <div class="col-8 item">
                <p-radioButton formControlName="isActivated" name="isActivated" value="1" label="Y" [(ngModel)]="tariffRate.isActivated"></p-radioButton>
                <p-radioButton formControlName="isActivated" name="isActivated" value="0" label="N" [(ngModel)]="tariffRate.isActivated" class="ml-2"></p-radioButton>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'TariffRateNew.StartDate' | translate }}</label>
              <div class="col-8 item">
                <p-calendar dataType="string" dateFormat="yy/mm/dd" [class]="(submitted && f.startDtTimeZone.errors) ? ['ng-invalid', 'ng-dirty'] : []" formControlName="startDtTimeZone" [(ngModel)]="tariffRate.startDtTimeZone"></p-calendar>
                <small *ngIf="submitted && f.startDtTimeZone.errors" class="errors">
                    <div *ngIf="f.startDtTimeZone.errors.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'TariffRateNew.EndDate' | translate }}</label>
              <div class="col-8 item">
                <p-calendar dataType="string" dateFormat="yy/mm/dd" [class]="(submitted && f.endDtTimeZone.errors) ? ['ng-invalid', 'ng-dirty'] : []" formControlName="endDtTimeZone" [(ngModel)]="tariffRate.endDtTimeZone"></p-calendar>
              </div>
            </div>
          </div>
          <div class="grid">
              <div class="col">
                  <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveBtn($event)" class="mr-2"></button>
                  <button pButton pRipple label="{{ 'Common.Button.ReturnWithoutSaving' | translate }}" (click)="goToLastPage()" class="mr-2"></button>
              </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
  </p-card>
</div>
